/**
 * URL query param keys the marketing site attaches to portal links.
 */
export enum UtmQueryParamKey {
  SOURCE = 'utm_source',
  MEDIUM = 'utm_medium',
  CAMPAIGN = 'utm_campaign',
  TERM = 'utm_term',
  CONTENT = 'utm_content',
}

/**
 * localStorage / cookie key the captured UTM params are persisted under.
 */
export enum UtmStorageKey {
  UTM_PARAMS = 'kollabhr_utm_params',
}
